import { render, staticRenderFns } from "./ReceivablesTable.vue?vue&type=template&id=6be488a2&scoped=true&"
import script from "./ReceivablesTable.vue?vue&type=script&lang=js&"
export * from "./ReceivablesTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceivablesTable.vue?vue&type=style&index=0&id=6be488a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be488a2",
  null
  
)

export default component.exports